export const toggleCollapsePanelShown = (e) => {
  var parent = e.target.parentNode
  parent.classList.toggle('is-open')
}

export const faqFunction = () => {
  var elements = document.getElementsByClassName('collapsepanel')
  for (let i = 0; i < elements.length; i++) {
    elements[i].addEventListener('click', toggleCollapsePanelShown, false)
  }
}

export const hideLink = () => {
  window.open(
    'https://fiinvosyapiresource8f98.blob.core.windows.net/fiinvosydocs/INVOSY_K%C3%A4ytt%C3%B6opas_User_manual.pdf'
  )
}
export const hideLink1 = () => {
  window.open(
    'https://fiinvosyapiresource8f98.blob.core.windows.net/fiinvosydocs/Vakuutusnumero_7839134.pdf'
  )
}
export const hideLink2 = () => {
  window.open(
    'https://fiinvosyapiresource8f98.blob.core.windows.net/fiinvosydocs/Invosy_Finland_Oy_vastuutodistus_490-7407211.pdf'
  )
}
export const hideLink3 = () => {
  window.open(
    'https://fiinvosyapiresource8f98.blob.core.windows.net/fiinvosydocs/INVOSY_Toimeksiantosopimus_2024.pdf'
  )
}
export const hideLink4 = () => {
  window.open(
    'https://fiinvosyapiresource8f98.blob.core.windows.net/fiinvosydocs/MARKKINOINTIOPAS_Invosy_Finland.pdf'
  )
}
export const hideLink5 = () => {
  window.open(
    'https://fiinvosyapiresource8f98.blob.core.windows.net/fiinvosydocs/INVOSY_K%C3%A4ytt%C3%B6opas_User_manual.pdf'
  )
}

export const langQuery = (string, substring) => {
  let index = string.search(substring)
  if (index !== -1) {
    let langString = string.slice(index)
    let siteLang = langString.split('=')
    return siteLang[1]
  }
  return 'fi'
}
